import React from 'react';
import '../../styles/RateCard.css';

const EventsBeHealthSponsors = () => {
    return (
        <section className="events-be-health-sponsors-section py-5">
            <div className="container">
                <div className='rate-card-subtitle-container text-center mt-5 mb-5' data-aos="fade-up" data-aos-delay="200">
                    <div className='inline-flex justify-content-center align-items-center mb-4'>
                        <img src="assets/behealth-events-1.png" alt="logo BeHealth Events" className='img-fluid m-2' />
                        <h2 className='rate-card-subtitle pb-2'>(Auspicios)</h2>
                    </div>
                    <p>Opta por la modalidad de auspicio que mejor se adapte a tus objetivos. En BeHealth ofrecemos tres
                        niveles de participación, diseñados para maximizar la visibilidad y el impacto de tu marca en nuestros eventos.
                    </p>
                </div>

                <div className='row justify-content-center'>
                    <div className='col-lg-3 col-md-6 mb-4 mt-4' data-aos="fade-up" data-aos-delay="200">
                        <div className='events-be-health-sponsors-col rounded shadow-lg'>
                            <div className='events-be-health-sponsors-col-title position-relative rounded'>
                                <h3 className='pt-2 pb-2 fw-bold'>PREMIUM</h3>
                                <div className='position-absolute top-100 start-50 translate-middle'>
                                    <svg width="4em" height="4em" viewBox="0 0 16 16" class="position-absolute top-100 start-50 translate-middle bi bi-caret-down-fill" fill="#ffffff" xmlns="http://www.w3.org/2000/svg"><path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" /></svg>
                                </div>
                            </div>

                            <div className='position-relative p-3'>
                                <ul className="mt-4 custom-bullets text-start">
                                    <li>Máxima visibilidad y beneficios exclusivos.</li>
                                    <li>Logotipo en todas las piezas de comunicación: sitio web, redes sociales, emails, carteles y merchandising.</li>
                                    <li>Exclusividad en los espacios publicitarios de la landing del evento.</li>
                                    <li>Artículos contextuales para profundizar en la temática.</li>
                                    <li>Presencia destacada: Stands, banners y pancartas en ubicaciones preferenciales.</li>
                                    <li>Menciones en comunicados de prensa y redes sociales.</li>
                                </ul>
                            </div>

                            <div className='position-absolute top-100 start-50 translate-middle'>
                                <svg width="4em" height="4em" viewBox="0 0 16 16" class="position-absolute top-100 start-50 translate-middle bi bi-caret-down-fill" fill="#2daa66" xmlns="http://www.w3.org/2000/svg"><path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" /></svg>
                            </div>
                        </div>
                    </div>

                    <div className='col-lg-3 col-md-6 mb-4 mt-4' data-aos="fade-up" data-aos-delay="300">
                        <div className='events-be-health-sponsors-col rounded shadow-lg'>
                            <div className='events-be-health-sponsors-col-title position-relative rounded'>
                                <h3 className='pt-2 pb-2 fw-bold'>ALL ACCESS</h3>
                                <div className='position-absolute top-100 start-50 translate-middle'>
                                    <svg width="4em" height="4em" viewBox="0 0 16 16" class="position-absolute top-100 start-50 translate-middle bi bi-caret-down-fill" fill="#ffffff" xmlns="http://www.w3.org/2000/svg"><path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" /></svg>
                                </div>
                            </div>

                            <div className='position-relative p-3'>
                                <ul className="mt-4 custom-bullets text-start">
                                    <li>Todo lo incluido en el paquete <span>PREMIUM</span>, sumado a: Discurso o presentación en el evento.</li>
                                    <li>Inclusión de productos o folletos en los kits o bultos de regalo.</li>
                                </ul>
                            </div>

                            <div className='position-absolute top-100 start-50 translate-middle'>
                                <svg width="4em" height="4em" viewBox="0 0 16 16" class="position-absolute top-100 start-50 translate-middle bi bi-caret-down-fill" fill="#26c757" xmlns="http://www.w3.org/2000/svg"><path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" /></svg>
                            </div>
                        </div>
                    </div>

                    <div className='col-lg-3 col-md-6 mb-4 mt-4' data-aos="fade-up" data-aos-delay="400">
                        <div className='events-be-health-sponsors-col rounded shadow-lg'>
                            <div className='events-be-health-sponsors-col-title position-relative rounded'>
                                <h3 className='pt-2 pb-2 fw-bold'>PLUS</h3>
                                <div className='position-absolute top-100 start-50 translate-middle'>
                                    <svg width="4em" height="4em" viewBox="0 0 16 16" class="position-absolute top-100 start-50 translate-middle bi bi-caret-down-fill" fill="#ffffff" xmlns="http://www.w3.org/2000/svg"><path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" /></svg>
                                </div>
                            </div>

                            <div className='position-relative p-3'>
                                <ul className="mt-4 custom-bullets text-start">
                                    <li>Visibilidad destacada pero sin exclusividad.</li>
                                    <li>Logotipo en sitio web y materiales de comunicación.</li>
                                    <li>Artículos contextuales para fortalecer la presencia de marca.</li>
                                    <li>Espacio para stand o banner en ubicación secundaria.</li>
                                    <li>Mención en redes sociales con publicaciones dedicadas o etiquetado.</li>
                                </ul>
                            </div>

                            <div className='position-absolute top-100 start-50 translate-middle'>
                                <svg width="4em" height="4em" viewBox="0 0 16 16" class="position-absolute top-100 start-50 translate-middle bi bi-caret-down-fill" fill="#10857f" xmlns="http://www.w3.org/2000/svg"><path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" /></svg>
                            </div>
                        </div>
                    </div>

                    <div className='col-lg-3 col-md-6 mb-4 mt-4' data-aos="fade-up" data-aos-delay="500">
                        <div className='events-be-health-sponsors-col rounded shadow-lg'>
                            <div className='events-be-health-sponsors-col-title position-relative rounded'>
                                <h3 className='pt-2 pb-2 fw-bold'>ALL ACCESS</h3>
                                <div className='position-absolute top-100 start-50 translate-middle'>
                                    <svg width="4em" height="4em" viewBox="0 0 16 16" class="position-absolute top-100 start-50 translate-middle bi bi-caret-down-fill" fill="#ffffff" xmlns="http://www.w3.org/2000/svg"><path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" /></svg>
                                </div>
                            </div>

                            <div className='position-relative p-3'>
                                <ul className="mt-4 custom-bullets text-start">
                                    <li>Visibilidad básica en el evento.</li>
                                    <li>Logotipo en el sitio web del evento.</li>
                                    <li>Presencia en material impreso (carteles o folletos).</li>
                                    <li>Posibilidad de tener un banner o pequeño stand.</li>
                                </ul>
                            </div>

                            <div className='position-absolute top-100 start-50 translate-middle'>
                                <svg width="4em" height="4em" viewBox="0 0 16 16" class="position-absolute top-100 start-50 translate-middle bi bi-caret-down-fill" fill="#17ada2" xmlns="http://www.w3.org/2000/svg"><path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" /></svg>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="tab-label mt-4">Eventos</div>
            </div>
        </section>
    );
};

export default EventsBeHealthSponsors;
